<template>
  <div class="container-fluid">
    <div align="left">
        <el-form
            style="margin-top: 15px"
            size="large"
            :inline="true"
            :model="search"
        >
            <el-form-item label="生产日期：">
                <el-date-picker
                    v-model="search.product_date"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="large"
                    style="width:165px;"
                    :disabled="search.p_status==1"
                    placeholder="product time"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="公仔名称：" style="margin-left:20px;">
                <el-select v-model="search.craftie_uuid" :disabled="(search.p_status==1 && search.create_user_email == user_email)" style="width:180px;" size="large" filterable placeholder="craftie name" @change="crafiteChange">
                    <el-option v-for="item in crafite_list" :key="item.crafite_uuid" :value="item.crafite_uuid" :label="item.crafite_name + (item.isdoing?'（计数中）':'')"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="烧录设备：" style="margin-left:20px;">
                <el-select v-model="search.device_id" style="width:180px;" size="large" :disabled="search.p_status==1" filterable placeholder="device id">
                    <el-option v-for="item in device_list" :key="item.device_id" :value="item.device_id" :label="item.device_id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
    </div>
    <div style="display:flex;margin-bottom:20px;margin-top: 20px;justify-content:space-between;">
        <div style="display:flex;justify-content:space-between;width:60%;">
            <el-button :icon="search.p_status==1?'el-icon-loading':'el-icon-video-play'" type="primary" :disabled="search.p_status==1" @click="startStatistic()">{{search.p_status==1?'正在计数':'开始计数'}}</el-button>
            <div style="display:flex;align-items:center;">
                <div>统计数量：</div>
                <el-input style="width:100px;" :disabled="search.p_status==1" type="number" v-model="search.product_count" placeholder="请输入数量"></el-input>
            </div>
            <div style="display:flex;align-items:center;">
                <div>成功数量：</div>
                <el-input style="width:100px;" :disabled="true" type="number" v-model="actual_count"></el-input>
            </div>
            <div style="display:flex;">
                <el-button icon="el-icon-switch-button" :disabled="(search.p_status!=1 || search.create_user_email != user_email)" type="primary" @click="stopStatistic()">结束计数</el-button>
                <el-button v-if="search.p_status==2" type="primary" @click="exportCsv()">导出</el-button>
            </div>
        </div>
        <div style="display:flex;align-items:center;">
            <el-button icon="el-icon-refresh" type="primary" :disabled="search.p_status!=1" size="small" @click="loadData()">刷新</el-button>
            <div style="display:flex;align-items:center;margin-left:40px;">
                <div style="font-size:14px;">自动刷新时间：</div>
                <el-select v-model="reflesh_time" size="large" :disabled="search.p_status!=1" @change="setMyInterval()" style="width:100px;">
                    <el-option v-for="item in speed_list" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </div>
        </div>
    </div>
    <div style="margin-bottom: 6px">
      <el-table v-tb-height="{self:this}" ref="table" border :data="data_list" :height="height" empty-text="Temporarily no data">
        <el-table-column label="No" type="index"></el-table-column>
        <el-table-column align="center" label="公仔名称" prop="crafite_name" ></el-table-column>
        <el-table-column align="center" label="公仔ID" prop="craftie_no">
            <template slot-scope="scope">
                <a @click="copy(scope.row.craftie_no)" style="color:#409EFF;">{{scope.row.craftie_no}}</a>
            </template>
        </el-table-column>
        <el-table-column align="center" label="物理ID" prop="physical_id">
            <template slot-scope="scope">
                <a @click="copy(scope.row.physical_id)" style="color:#409EFF;">{{scope.row.physical_id}}</a>
            </template>
        </el-table-column>
        <el-table-column align="center" label="烧录时间" prop="">
          <template slot-scope="scope">
            <p>{{scope.row.create_time}}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import json2csv from "json2csv"
  export default {
    name: 'ProductSearch',
    components: {},
    data () {
      return {
        height: 0,
        user_email: "",
        doing_list: [],
        search: {
            id: 0,
            create_user_email: "",
            p_status: 0,
            start_time: "",
            product_count: 0,
            craftie_uuid: '',
            device_id: '',
            product_date: "",
        },
        speed_list: [
            { label: '5s', value: 5000 },
            { label: '10s', value: 10000 },
            { label: '30s', value: 30000 }
        ],
        reflesh_time: 5000,
        actual_count: 0,
        data_list: [],
        crafite_list:[],
        device_list:[],
        interval: null
      }
    },
    computed: {},
    created () {
      this.initData()
    },
    beforeDestroy () {
        if(this.interval){
            clearInterval(this.interval);
        }
    },
    methods: {
        initData () {
            const user_email = this.$util.fetch('user_email');
            this.user_email=user_email;
            this.$api.rootV1.get('/web/craftiesearch/init', {}, (res1) => {
                let {crafite_list,device_list} = res1.data;
                this.device_list = device_list;
                this.getDoingList(crafite_list, user_email, true);
            })
        },

        getDoingList(crafite_list,user_email,isInit = false){
            this.$api.rootV1.get('/web/craftiesearch/statistic', {}, (res) => {
                if(res.errcode == 0 && res.data.length>0){
                    const doing_list = res.data;
                    if(isInit){
                        for(let i = 0; i < doing_list.length; i++){
                            const item = doing_list[i];
                            if(item.create_user_email == user_email){
                                this.search = item;
                                this.setMyInterval();
                                break;
                            }else if(i == doing_list.length - 1){
                                this.search.product_date = this.formDate(1);
                            }
                        }
                    }
                    doing_list.forEach((item) => {
                        crafite_list.forEach(citem => {
                            if(citem.crafite_uuid==item.craftie_uuid){
                                citem.isdoing = 1;
                            }else{
                                citem.isdoing = 0;
                            }
                        })
                    })
                    this.doing_list = doing_list;
                }else {
                    crafite_list.forEach(citem => {
                        citem.isdoing = 0;
                    })
                    if(isInit){
                        this.search.product_date = this.formDate(1);
                    }
                }
                this.crafite_list = crafite_list;
            })
        },

        copy(data){
            let url = data;
            let oInput = document.createElement('input');
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$message({
                message: '复制成功',
                type: 'success'
            });
            oInput.remove()
        },

        formDate (form=1) {
            var dd = new Date();
            var y = dd.getFullYear();
            var M = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
            var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
            var h = dd.getHours() < 10 ? "0" + dd.getHours() : dd.getHours();
            var m = dd.getMinutes() < 10 ? "0" + dd.getMinutes() : dd.getMinutes();
            var s = dd.getSeconds() < 10 ? "0" + dd.getSeconds() : dd.getSeconds();
            switch(form){
                case 1: return y + "-" + M + "-" + d;
                case 2: return h + ":" + m + ":" + s;
                case 3: return y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
                default: return y + "-" + M + "-" + d;
            }
        },

        crafiteChange(e){
            const doing_list =JSON.parse(JSON.stringify(this.doing_list));
            for(let i = 0; i < doing_list.length; i++ ){
                const item = doing_list[i];
                if(item.craftie_uuid == e){
                    this.search = item;
                    this.setMyInterval();
                    break;
                }else if(i == doing_list.length - 1){
                    this.search.id = 0;
                    this.search.create_user_email = "";
                    this.search.p_status = 0;
                    this.search.start_time = "";
                    this.search.product_count = 0;
                    this.search.device_id = "";
                    if(this.interval){
                        clearInterval(this.interval)
                        this.interval=null;
                    }
                }
            }
        },

        startStatistic(){
            const { product_count, craftie_uuid, device_id, product_date } = this.search;
            if(!product_date){
                this.$message.error('请先选择生产日期');
                return ;
            }
            if(!craftie_uuid){
                this.$message.error('请先选择要统计的公仔');
                return ;
            }
            if(!device_id){
                this.$message.error('请先选择烧录设备');
                return ;
            }
            if(!product_count){
                this.$message.error('请先输入统计数量');
                return ;
            }
            let params = this.search;
            const user_email = this.user_email;
            params.user_email=user_email;
            this.$api.rootV1.post('/web/craftiesearch/statistic/start', params, (res) => {
                if(res.errcode===0){
                    this.search.id = res.data.insertId;
                    this.search.p_status = 1;
                    this.search.create_user_email = user_email;
                    this.search.start_time =this.search.product_date + " " + this.formDate(2)
                    this.setMyInterval();
                    this.getDoingList(this.crafite_list, this.user_email, false)
                    this.$message.success('开始计数成功，正在计数中...')
                }
            },(err) => {
                this.$alert(err.errmsg, "info", {
                    confirmButtonText: "confirm",
                    type: "error",
                    callback: action => {
                        this.getDoingList(this.crafite_list, this.user_email, false)
                    }
                });
            })
        },

        stopStatistic(){
            let params = {
                id: this.search.id,
                actual_count: this.actual_count
            }
            this.$api.rootV1.post('/web/craftiesearch/statistic/stop', params, (res) => {
                if(res.errcode===0){
                    this.search.p_status = 2;
                    this.$message.success('结束计数成功')
                    this.getDoingList(this.crafite_list, this.user_email, false)
                    clearInterval(this.interval);
                    this.interval=null;
                }
            })
        },

        loadData () {
            const { start_time,craftie_uuid,device_id} = this.search;
            const params = {
                device_id,
                start_time,
                crafite_uuid: craftie_uuid
            }
            this.$api.rootV1.post('/web/craftiesearch/statistic/search', params, (res) => {
                if(res.errcode===0){
                    this.data_list = res.data;
                    this.actual_count = res.data.length
                    if(res.data.length >= this.search.product_count){
                        this.stopStatistic();
                    }
                }
            })
        },

        setMyInterval(){
            if(this.interval){
                clearInterval(this.interval)
            }
            this.interval = setInterval(() => {
                this.loadData();
            }, this.reflesh_time);
        },

        exportCsv(){
            try{
                const res = json2csv.parse(this.data_list,{excelStrings: true})
                if(this.isIE()){
                    let BOM ="\uFEFF";
                    var csvData = new Blob([BOM + res],{type: "text/csv"});
                    navigator.msSaveBlob(csvData,'product.csv');
                }else{
                    let csvContent = "data:type/csv;charset=utf-8,\uFEFF"+ res;
                    this.createDownLoadClick(csvContent,'product.csv');
                }
            }catch(err){
                console.log("out=== error",err);
            }
        },

        isIE(){
            let isIE = false;
            if(navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1){
                isIE = true
            }
            if(navigator.userAgent.indexOf("Trident") > -1){
                isIE = true
            }
            return isIE;
        },

        createDownLoadClick(content,fileName){
            const link = document.createElement("a");
            link.href = encodeURI(content);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/craftieSearch/ProductSearch.vue